/**
 *
 * Global Nav (JS)
 *
 * @author Takuto Yanagida @ Space-Time Inc.
 * @version 2020-03-23
 *
 */


(function () {

	const CLS_CURRENT       = 'current';
	const CLS_MENU_ANCESTOR = 'menu-ancestor';
	const CLS_PAGE_ANCESTOR = 'page-ancestor';

	const SEL_NAV_BAR        = '.site-global-nav-bar';
	const SEL_NAV_PANEL_WRAP = '.site-global-nav-panel-wrapper';

	const CLS_OPENED  = 'opened';
	const CLS_TOUCHED = 'touched';

	const PX_OFFSET_SCROLL = 20;


	document.addEventListener('DOMContentLoaded', function () {
		const menuItems = document.querySelectorAll(SEL_NAV_BAR + ' label[for]');
		const panelWrap = document.querySelector(SEL_NAV_PANEL_WRAP);

		const gn = new GlobalNav({
			menuItems   : menuItems,
			wrapper     : panelWrap,
			autoClose   : true,
			onBeforeOpen: onBeforeOpen,
		});
		scrollMenu(SEL_NAV_BAR, PX_OFFSET_SCROLL);
	});


	// -------------------------------------------------------------------------


	function onBeforeOpen(item, panel) {
		if (!panel) return;
		const w = window.innerWidth;
		if (w <= 600) {
			panel.style.left  = '';
			panel.style.right = '';
			return;
		}
		const bcrI  = item.getBoundingClientRect();
		const bcrP  = panel.getBoundingClientRect();
		const bcrPP = panel.parentElement.getBoundingClientRect();
		const wP    = bcrP.right - bcrP.left;
		const wPP   = bcrPP.right - bcrPP.left;
		const l     = bcrI.left - bcrPP.left;

		if (wPP < l + wP + 16) {
			panel.style.left  = '';
			panel.style.right = '0px';
		} else {
			panel.style.left  = l + 'px';
			panel.style.right = '';
		}
	}


	// -------------------------------------------------------------------------


	function scrollMenu(selBar, scrollOffset) {
		const mis = document.querySelectorAll(selBar + ' .menu > li');

		for (let i = 0; i < mis.length; i += 1) {
			if (mis[i].classList.contains(CLS_CURRENT) ||
				mis[i].classList.contains(CLS_MENU_ANCESTOR) ||
				mis[i].classList.contains(CLS_PAGE_ANCESTOR))
			{
				doScroll(mis[i]);
			}
			mis[i].firstChild.addEventListener('click', () => { doScroll(mis[i]); });
		}
		function doScroll(curMi) {
			let m = curMi.parentElement;
			while (!m.classList.contains('scroll')) m = m.parentElement;
			if (!m) return;

			const right = curMi.offsetLeft + curMi.offsetWidth;
			if (m.offsetWidth < right) m.scrollLeft = curMi.offsetLeft - scrollOffset;
			if (curMi.offsetLeft < m.scrollLeft) m.scrollLeft = curMi.offsetLeft - scrollOffset;
		}
	}


	// -------------------------------------------------------------------------


	class GlobalNav {

		constructor(opts) {
			this._openItem  = null;
			this._openTime  = 0;
			this._scrollTop = 0;
			this._st        = null;

			this._isFirefox = window.ST.BROWSER === 'firefox';

			const menuItems      = opts['menuItems']       ? opts['menuItems']       : null;
			this._defMenuItem    = opts['defaultMenuItem'] ? opts['defaultMenuItem'] : null;
			this._wrap           = opts['wrapper']         ? opts['wrapper']         : null;
			const autoClose      = opts['autoClose']       ? opts['autoClose']       : false;
			const groupingSuffix = opts['groupingSuffix']  ? opts['groupingSuffix']  : '';
			this._child          = opts['childNav']        ? opts['childNav']        : null;
			this._onBeforeOpen   = opts['onBeforeOpen']    ? opts['onBeforeOpen']    : null;

			this._panels = Array.prototype.slice.call(this._wrap.children);
			this._dummy  = this.initPanelRadios(this._panels, groupingSuffix);

			this.addClickStateEventListener(menuItems);
			if (this._defMenuItem) this.open(this._defMenuItem);

			if (autoClose) {
				window.ST.onScroll(() => { this.onScroll(); });
				this._wrap.addEventListener('click', e => e.stopPropagation());
				document.addEventListener('click', () => { this.closeAll(); });
			}
		}

		initPanelRadios(panels, groupingSuffix) {
			let dummy = null;
			for (let i = 0; i < panels.length; i += 1) {
				const p = panels[i];
				if (i === 0) {
					dummy = this.createRadio('panel-dummy-ctrl', groupingSuffix);
					this._wrap.insertBefore(dummy, p);
				}
				const id = p.id;
				this._wrap.insertBefore(this.createRadio(id + '-ctrl', groupingSuffix), p);
			}
			if (dummy === null) {
				dummy = this.createRadio('panel-dummy-ctrl', groupingSuffix);
				this._wrap.insertBefore(dummy, null);
			}
			return dummy;
		}

		createRadio(id, groupingSuffix) {
			const e = document.createElement('input');
			e.id   = id;
			e.type = 'radio';
			e.name = 'panel-radios' + groupingSuffix;  // Must set the same name
			return e;
		}

		addClickStateEventListener(items) {
			if ('ontouchstart' in window) {
				for (let i = 0; i < items.length; i += 1) {
					items[i].addEventListener('click', this.createEventListenerTouch(items[i]));
					items[i].addEventListener('touchstart', () => {  // for avoiding hover style
						items[i].classList.add(CLS_TOUCHED);
						items[i].parentElement.classList.add(CLS_TOUCHED);
					});
				}
			} else {
				for (let i = 0; i < items.length; i += 1) {
					items[i].addEventListener('mouseenter', this.createEventListenerEnter(items[i]));
					items[i].addEventListener('mouseleave', this.createEventListenerLeave());
					items[i].addEventListener('click',      this.createEventListenerClick(items[i]));
				}
				for (let i = 0; i < this._panels.length; i += 1) {
					this._panels[i].addEventListener('mouseenter', () => {
						if (this._st) clearTimeout(this._st);
						this._st = null;
					});
				}
			}
		}


		// ---------------------------------------------------------------------


		closeAll() {
			if (this._defMenuItem) {
				this.open(this._defMenuItem);
				return;
			}
			this.clearStateOpened();
			this._dummy.click();
			if (this._st) clearTimeout(this._st);
			this._st = null;
		}

		open(item, clickAgain = false) {
			this.clearStateOpened();
			item.click();
			item.parentElement.classList.add(CLS_OPENED);
			setTimeout(() => {
				if (this._isFirefox && clickAgain) item.click();  // Click again for Firefox
				const p = this.itemToPanel(item);
				if (p) p.classList.add(CLS_OPENED);
				if (this._onBeforeOpen) this._onBeforeOpen(item, p);
			}, this._isFirefox ? 20 : 0);  // Delay time 20ms is for Firefox
			this._openItem = item;
			this._openTime = new Date().getTime();
			this._scrollTop = window.pageYOffset;
			this._st = null;
		}

		clearStateOpened() {
			if (this._child) this._child.closeAll();
			if (!this._openItem) return;
			this._openItem.parentElement.classList.remove(CLS_OPENED);
			const item = this._openItem;
			setTimeout(() => {
				if (item === this._openItem) return;
				const p = this.itemToPanel(item);
				if (p) p.classList.remove(CLS_OPENED);
			}, 400);
			this._openItem = null;
		}

		itemToPanel(item) {
			const tarId = item.getAttribute('for');
			if (tarId) {
				const radio = document.getElementById(tarId);
				if (radio) return radio.nextElementSibling;
			}
			return null;
		}

		onScroll() {
			if (this._child && this._child._openItem) return;
			if (this._openItem) {
				const openPanel = this._wrap.querySelector("input[type='radio']:checked + *");
				if (!openPanel) return;
				const bcr = openPanel.getBoundingClientRect();
				if (
					bcr.bottom < 0 ||  // When not fixed
					(0 < bcr.top && bcr.bottom < Math.abs(window.pageYOffset - this._scrollTop))  // When fixed
				) {
					this.closeAll();
				}
			}
		}


		// ---------------------------------------------------------------------


		createEventListenerTouch(item) {
			return (e) => {
				e.stopPropagation();
				if (item === this._openItem) {
					e.preventDefault();
					this.closeAll();
				} else {
					this.open(item);
				}
			};
		}


		// ---------------------------------------------------------------------


		createEventListenerEnter(item) {
			return (e) => {
				if (item === this._openItem) {
					e.preventDefault();
				} else {
					if (this._st) clearTimeout(this._st);
					this._st = setTimeout(() => {
						this.open(item);
					}, this._openItem !== null ? 400 : 200);
				}
			};
		}

		createEventListenerLeave() {
			return (e) => {
				if (this._st) clearTimeout(this._st);
				this._st = setTimeout(() => { this.closeAll() }, 800);
			};
		}

		createEventListenerClick(item) {
			return (e) => {
				e.stopPropagation();
				if (this._st) clearTimeout(this._st);
				const t = new Date().getTime();
				if (t - this._openTime < 200) return;
				if (item === this._openItem) {
					e.preventDefault();
					this.closeAll();
				} else {
					this.open(item, true);
				}
			};
		}

	}

})();
